import { render } from "./UnitLevel.vue?vue&type=template&id=a07737dc&scoped=true"
import script from "./UnitLevel.vue?vue&type=script&lang=js"
export * from "./UnitLevel.vue?vue&type=script&lang=js"

import "./UnitLevel.vue?vue&type=style&index=0&id=a07737dc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a07737dc"]])

export default __exports__